(function($){
    const $fn = $(".part_banner");

    if ($fn.length) {
        $(document).on("click","[data-banner-close]", function(){
            $fn.slideUp(300).addClass("mod--disabled");
        });
    }
})(jQuery);